import React, { useContext } from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../../styles/theme/aistheme.css";
import "../../../styles/theme/sharedThemeOverride.css";

import { MenuItem, MenuItemType } from "../../../globals/data/menuData/menuData";
import { changeLandingContentView } from "../../../globals/observables/landing/landingContentObservable";
import { AIS_WORKER_VERSION } from "../../../globals/context/globalContext";
import { GetServiceSpecification } from "../../serviceEndpoints/serviceLookups";



const GeneralButtonStyle = {
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  color: "black",
  height: "35px",
  marginTop: "auto",
  marginBottom: "auto",
  width: "35px",
  backgroundColor: "gray",
  maxHeight: "35px !Important",
  maxWidth: "35px  !Important",
  minHeight: "35px !Important",
  minWidth: "35px  !Important",
  padding: "0px"
};


const WrapperContainer = styled("div")(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;

    background-color: blue;

    flex-bassis:100%;

    
    `
);



const DisplayLabelContainer = styled("div")(
  ({ theme }) => `
    color: #FFFFFF;
    
    margin-top: 0px;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
  
    font-family: 'poppins';
    font-weight: 400;
    font-size: calc(16px + (20 - 16) * ((100vw - 1366px) / (2560 - 1366)));
  
  
    `
);



interface HeaderProps {

}


function AliPagePresenter(props: HeaderProps) {

  const WORKER_VERSION = useContext<string>(AIS_WORKER_VERSION);





  const ExecuteDoSomething = async (token: string, userProfileRef: string) => {



    //The service spec contains the method and the endpoint to use
    const serviceSpec = GetServiceSpecification(
      WORKER_VERSION,
      'COMPUTE_BALANCE_GET_ENDPOINT'
    )


    //Match the object TYPES in here and in the worker

    // const request: Fleet_Account_StripeCustomer_New = {
    //   accountName: accountName,
    //   accountEmailAddress: emailAddress,
    //   fleetRef: fleetSpecDataContext.fleetData.fleetReference
    // }


    // //Call our endpoint to get these details back..
    // const collectionResult = await ExecuteAliPageServiceEnpoint(
    //   authSessionContext,
    //   serviceSpec.method,
    //   serviceSpec.endpoint,
    //   JSON.stringify(request)
    // )


    // if (collectionResult.hasError) {
    //   //TODO: log this. 
    //   throw ('Failed to perform compute/balance/get');
    // }

    // const result: CreateStripeCustomerResponse = JSON.parse(collectionResult.resultBody);

    // if (result.hasError === true) {
    //   //Show failure
    //   setShowFailureCreatingAccount(true);
    //   setShowCreatingAccount(false);
    //   return;
    // }

    // //All good - lets go
    // await setComputeAccountViewState(
    //   ComputeAccountViewState.USE_ACCOUNT,
    //   result.stripeCustomerId
    // );


    //const executionResult = await GetAllStaff(token,body);
    //console.log('Result =>', executionResult .json());

  }


  const handleMovePage = async ()=>{

    await changeLandingContentView(
      MenuItemType.ALI_SUB_PAGE,
      'sub_ref'
    )

  }



  return (
    <WrapperContainer id="mennu block WrapperContainer">
      <DisplayLabelContainer>
        AliPagePresenter 1

        <button
          onClick={handleMovePage}
        >
          Go
        </button>
      </DisplayLabelContainer>
    </WrapperContainer>

  )
}


export default AliPagePresenter;